
const accounting = require('accounting');

const _ = require('lodash');

// Settings object that controls default parameters for library methods:
accounting.settings = _.defaults({
	currency: {
		symbol: "$",   // default currency symbol is '$'
		format: "%v %s", // controls output: %s = symbol, %v = value/number (can be object: see below)
		decimal: ",",  // decimal point separator
		thousand: " ",  // thousands separator
		precision: 2,   // decimal places
	},
	number: {
		precision: 0,  // default precision on numbers is 0
		thousand: ",",
		decimal: ".",
	},
}, accounting.settings);

module.exports = accounting;

